<template>
  <div class="relative" :data-section-key="sectionKey">
    <!-- Toggle bar visible only in form editor mode (for users with manage permission) -->
    <div
      v-if="isFormEditorMode && canManage"
      class="flex items-center justify-between rounded-t-lg border-x border-t border-indigo-200 bg-indigo-50 px-3 py-1.5"
    >
      <span class="text-xs font-medium" :class="{ 'text-indigo-400': !isHidden, 'text-red-400': isHidden }">
        {{ isHidden ? $t('global.section_hidden') : $t('global.section') }}
      </span>
      <button
        class="flex items-center gap-1.5 rounded-md px-2 py-1 text-xs font-medium transition"
        :class="{
          'text-gray-600 hover:bg-indigo-100 hover:text-red-500': !isHidden,
          'text-gray-400 hover:bg-gray-100 hover:text-green-600': isHidden,
        }"
        @click="handleToggleVisibility"
      >
        <FontAwesomeIcon :icon="['fal', isHidden ? 'eye' : 'eye-slash']" />
        {{ isHidden ? $t('global.show_section') : $t('global.hide_section') }}
      </button>
    </div>

    <!-- Section content -->
    <div class="relative">
      <slot />
      <!-- Dimmed overlay for hidden sections in form editor mode -->
      <div
        v-if="isFormEditorMode && isHidden && canManage"
        class="absolute inset-0 z-10 flex cursor-pointer items-center justify-center rounded-lg bg-white/75"
        @click="handleToggleVisibility"
      >
        <span
          class="flex items-center gap-1.5 rounded-md border border-gray-200 bg-white px-3 py-1.5 text-sm text-gray-400 shadow-sm"
        >
          <FontAwesomeIcon :icon="['fal', 'eye-slash']" />
          {{ $t('global.section_hidden') }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

export default {
  name: 'SectionWrapper',
  components: { FontAwesomeIcon },
  inject: ['toggleSectionVisibility'],
  props: {
    sectionKey: {
      type: String,
      required: true,
    },
    canManage: {
      type: Boolean,
      required: false,
      default: false,
    },
    isHidden: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    isFormEditorMode() {
      return this.$store.getters['metadata/getGlobalFormEditionMode']
    },
  },
  methods: {
    handleToggleVisibility() {
      this.toggleSectionVisibility(this.sectionKey)
    },
  },
}
</script>
